<template>
  <div class="map-year-nav-btn"
    :class="textAlign">
    <span v-if="isDisabled"
      v-html="buttonText" class="year-nav-disabled">
    </span>
    <a tabindex="0"
      v-if="!isDisabled"
      v-html="buttonText"
      @click="navigateYears"
      v-on:keyup.enter="navigateYears"
      v-on:keyup.space="navigateYears"
      role="button">
    </a>
  </div>
</template>

<script>
export default {
  name: 'year-nav-button',
  props: ['state', 'direction', 'increment'],
  computed: {
    buttonText() {
      const faIconClass = this.direction > 0 ? 'fa-caret-right' : 'fa-caret-left';
      const icon = `<i class="fa ${faIconClass}"></i>`;
      if (this.increment === 'end' || this.increment === 'begining') {
        const srText = `<span class="sr-only">go to ${this.increment}</span>`;
        return `${icon}${icon}${srText}`;
      }
      return this.direction > 0 ? `<span class="increment-text">${this.increment}</span> ${icon}` :
        `${icon} <span class="increment-text">${this.increment}</span>`;
    },
    textAlign() {
      return this.direction > 0 ? 'text-right' : 'text-left';
    },
    isDisabled() {
      const isAscending = this.direction > 0;
      const currentStart = this.state.timeBlock.start;
      const maxStart = this.state.timeBlock.maxStart;

      if ((isAscending && currentStart === maxStart) ||
        (!isAscending && currentStart === 0)) {
        return true;
      }
      return false;
    },
  },
  methods: {
    navigateYears() {
      if (this.increment === 'begining') {
        this.state.timeBlock.start = 0;
      } else if (this.increment === 'end') {
        this.state.timeBlock.start = this.state.timeBlock.maxStart;
      } else {
        const movement = this.direction * this.increment;
        const newStart = this.state.timeBlock.start + movement;
        if (newStart > this.state.timeBlock.maxStart) {
          this.state.timeBlock.start = this.state.timeBlock.maxStart;
        } else if (newStart < 0) {
          this.state.timeBlock.start = 0;
        } else {
          this.state.timeBlock.start = newStart;
        }
      }
    },
  },
};
</script>

<style lang="less">
  .map-year-nav-btn {
    flex-grow: 1;
    padding: 0 5px;
    a {
      cursor: pointer;
      color: #555;
    }
    .year-nav-disabled {
      color: #fff;
    }
  }
  .increment-text {
    font-size: 1em;
  }
</style>



// WEBPACK FOOTER //
// MapControlsYearNavigationButton.vue?917ce4ec